import { ofServiceDocument } from '@mimir/client-common/aws/api/basicPaths';
import { resolveServiceDocumentRootUrl } from '@mimir/common/deployment/resolveUrl';

export function getServicePath() {
  return ofServiceDocument(getRootUrl());
}

/**
 * Since the service document is served by a lambda, when running locally,
 * the port will be different than the port of the current location in the
 * browser's address bar. This is why we check whether or not the location
 * port is different from the port defined in the environment variable.
 *
 * Comparing the ports instead of looking for 'localhost' as the hostname
 * is more robust as it will work with other ways to refer to the local host
 * like 127.X.X.X addresses or the local machine name.
 */
export function getRootUrl(): string {
  const urlFromEnv = resolveServiceDocumentRootUrl(import.meta.env.MODE ? import.meta.env : process.env);
  const url = document.createElement('a');
  url.href = urlFromEnv;
  return url.port !== window.location.port ? urlFromEnv : window.location.origin;
}
